import { z } from 'zod';

export const LOGOUT_OPERATION_STATUS_PATH = '/api/auth/logout/status/:operationId';
export const LOGOUT_STATUS_TOKEN_HEADER = 'x-bunker-logout-status-token';

export const logoutOperationIdSchema = z.string().cuid();
export const logoutStatusTokenSchema = z.string().regex(/^[A-Za-z0-9_-]{43}$/);
export const logoutOperationSchema = z.object({
  id: logoutOperationIdSchema,
  statusToken: logoutStatusTokenSchema,
}).strict();
export const logoutOperationParamsSchema = z.object({ operationId: logoutOperationIdSchema }).strict();
export const logoutOperationStatusSchema = z.object({
  id: logoutOperationIdSchema,
  device: z.enum(['pending', 'complete']),
}).strict();
export const logoutResponseSchema = z.union([
  z.object({ ok: z.literal(true), device: z.literal('local') }).strict(),
  z.object({ ok: z.literal(true), device: z.enum(['pending', 'complete']), operation: logoutOperationSchema }).strict(),
]);

export type LogoutOperation = z.infer<typeof logoutOperationSchema>;
export type LogoutOperationStatus = z.infer<typeof logoutOperationStatusSchema>;
export type LogoutResponse = z.infer<typeof logoutResponseSchema>;
